"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Row", {
  enumerable: true,
  get: function get() {
    return _row["default"];
  }
});
Object.defineProperty(exports, "Col", {
  enumerable: true,
  get: function get() {
    return _col["default"];
  }
});

var _row = _interopRequireDefault(require("./row"));

var _col = _interopRequireDefault(require("./col"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/antd/lib/grid/index.js
// module id = 131
// module chunks = 0